import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { ObjectFilterPipe } from '../../../_pipes/object-filter.pipe';
import { CategoryService } from '../../../_services/category.service';
import { KioskCategoryService } from '../../../_services/kiosk-category.service';
import { CookieService } from 'ngx-cookie-service';
import { OrderGroupService } from '../../../_services/order-group.service';

@Component({
    selector: 'app-single-order-group-details',
    templateUrl: './single-order-group-details.component.html',
    styleUrls: ['./single-order-group-details.component.css']
})
export class SingleOrderGroupDetailsComponent implements OnInit {

    tabitems: any = [];
    orderGroupId: any;
    selectedOrderGroup: any;
    orderGroupDetailsForm: FormGroup;

    role: any;
    routeRole: any;

    cookieStore: any;
    storeId: any;

    constructor(
        fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public objectFilter: ObjectFilterPipe,
        public _categoryService: CategoryService,
        public _kioskCategoryService: KioskCategoryService,
        public cookieService: CookieService,
        public router: Router,
        public _orderGroupService: OrderGroupService
    ) {
        // Get builder id from params
        this.activatedRoute.params.subscribe((params: Params) => {
            this.orderGroupId = params.id;
        });

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.routeRole + '/select-store']);
        }

        this.tabitems = [
            { path: '/' + this.routeRole + '/order-groups/', title: 'All Workplace Groups', class: 'back-link' },
            { path: '/' + this.routeRole + '/order-groups/' + this.orderGroupId + '/details', title: 'Details' },
            { path: '/' + this.routeRole + '/order-groups/' + this.orderGroupId + '/slots', title: 'Slots' },
        ];

        this.orderGroupDetailsForm = fb.group({
            name: new FormControl(),
            identifier: new FormControl(),
            contact: new FormControl(),
            telephone: new FormControl(),
            address: new FormControl()
        });

    }

    ngOnInit() {
        this.getOrderGroup(this.orderGroupId);
    }

    // Get Order Group by id
    public getOrderGroup(id) {
        this._orderGroupService.getOrderGroupById(id)
            .subscribe((data: any) => {
                // console.log(data);
                this.selectedOrderGroup = data;
                this.assignFormValues();
            });
    }

    public assignFormValues() {
        this.orderGroupDetailsForm.patchValue({
            name: this.selectedOrderGroup.name,
            identifier: this.selectedOrderGroup.identifier,
            contact: this.selectedOrderGroup.contact,
            telephone: this.selectedOrderGroup.telephone,
            address: this.selectedOrderGroup.address
        })
    }

    // Submit Order Group Form Changes
    public onOrderGroupDetailsFormSubmit() {
        const values = this.orderGroupDetailsForm.value;
        // console.log(values);
        this._orderGroupService.editOrderGroup(this.orderGroupId, values)
            .subscribe((data: any) => {
                // console.log(data);
                this.getOrderGroup(this.orderGroupId);
                this.notificationService.notify(
                    'success',
                    'Order Group Updated',
                    'Order Group has successfully been updated',
                    'top',
                    'right');
            })
    }

}



// WEBPACK FOOTER //
// ./src/app/order-groups/single-order-group/single-order-group-details/single-order-group-details.component.ts